import { useIntl } from "react-intl";

import {
    ProductGrid,
    useProductData,
    ProductCategory,
    ProductItem,
    categories
} from "../product-subnav";

import { MobileNavTitle } from "./mobile-nav-card";

export const MobileNavProductLeadershipTeams = () => {
    const intl = useIntl();
    const { productsByTag } = useProductData();
    const leadershipTeamsProducts =
        productsByTag[ProductCategory.LeadershipTeams] || [];

    return (
        <div>
            <MobileNavTitle
                title={intl.formatMessage(
                    categories[ProductCategory.LeadershipTeams].title
                )}
            />
            <ProductGrid>
                {leadershipTeamsProducts.map((product) => (
                    <ProductItem key={product.id} {...product} />
                ))}
            </ProductGrid>
        </div>
    );
};
